import { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import useAuthStore from '../../store/authStore';

const normalizeKey = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]/g, '');

const AccessDenied = () => (
  <div className="min-h-[60vh] flex items-center justify-center p-6">
    <div className="max-w-md w-full bg-white border border-slate-100 shadow-sm rounded-3xl p-8 text-center">
      <p className="text-sm font-black tracking-[0.25em] text-red-500 uppercase">403</p>
      <h1 className="mt-2 text-2xl font-black text-slate-900">Bu işlem için yetkiniz yok</h1>
      <p className="mt-3 text-sm font-medium text-slate-500">
        Bu sayfaya erişmek için gerekli rol veya modül izni hesabınızda tanımlı değil.
      </p>
    </div>
  </div>
);

const ProtectedRoute = ({
  children,
  requiredModule,
  requiredModules = [],
  requiredAction = 'read',
  allowedRoles = [],
}) => {
  const location = useLocation();
  const user = useAuthStore((state) => state.user);
  const loading = useAuthStore((state) => state.loading);
  const hasPermission = useAuthStore((state) => state.hasPermission);

  const roleName = normalizeKey(user?.roleName);
  const normalizedRoles = allowedRoles.map(normalizeKey);
  const hasAllowedRole = normalizedRoles.length > 0 && normalizedRoles.includes(roleName);
  const modulesToCheck = Array.from(new Set([
    ...(Array.isArray(requiredModules) ? requiredModules : []),
    ...(requiredModule ? [requiredModule] : [])
  ])).filter(Boolean);
  const hasModulePermission = modulesToCheck.length > 0
    ? modulesToCheck.some((moduleName) => hasPermission(moduleName, requiredAction))
    : true;
  const isAuthorized = allowedRoles.length > 0
    ? hasAllowedRole || hasModulePermission
    : hasModulePermission;

  useEffect(() => {
    if (!loading && user && !isAuthorized) {
      toast.error('Bu işlem için yetkiniz yok.');
    }
  }, [isAuthorized, loading, user]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center font-bold">
        Yükleniyor...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (!isAuthorized) {
    return <AccessDenied />;
  }

  return children;
};

export default ProtectedRoute;
